module.exports = __webpack_public_path__ + "img/obj-rge-pp.94e7dcaf.png";